import { Input } from "@atomaro/ui-kit";
import { Wrapper } from "widgets/hud/ui/ApiariesPicker/ApiariesPicker.styles";
import { Apiary } from "shared/ui/icons/apiary";
import { ArrowRight } from "shared/ui/icons/arrowRight";
import { useApiariesStore } from "entities/apiaries";
import { useHudOverlay } from "widgets/hud/model/overlayStore";
import { useRef } from "react";
import { useHudCollapse } from "widgets/hud/model/collapseStore";

const TriggerIcon: React.FC<{ onTrigger: () => void; children: React.ReactNode }> = ({ onTrigger, children }) => (
    <span
        onPointerDown={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => { e.stopPropagation(); onTrigger(); }}
        style={{ display: "inline-flex" }}
    >
    {children}
  </span>
);

export const ApiariesPicker = () => {
    const currentApiary = useApiariesStore((s) => s.currentApiary());
    const apiaryName = currentApiary?.name ?? "";

    const openId = useHudOverlay((s) => s.openId);
    const open = useHudOverlay((s) => s.open);
    const close = useHudOverlay((s) => s.close);

    const collapsed = useHudCollapse((s) => s.collapsed);

    const lock = useRef(false);
    const cooldown = () => {
        lock.current = true;
        setTimeout(() => (lock.current = false), 300);
    };

    const handleClick = () => {
        if (lock.current) return;
        cooldown();
        if (openId === "apiaries-modal") {
            close();
        } else {
            open("apiaries-modal");
        }
    };

    return (
        <Wrapper
            $collapsed={collapsed}
            onPointerDownCapture={(e) => e.stopPropagation()}
            onMouseDownCapture={(e) => e.stopPropagation()}
        >
            <Input
                iconPrefix={
                    <TriggerIcon onTrigger={handleClick}>
                        <Apiary />
                    </TriggerIcon>
                }
                iconSuffix={
                    <TriggerIcon onTrigger={handleClick}>
                        <ArrowRight />
                    </TriggerIcon>
                }
                readOnly
                value={!collapsed ? apiaryName : ""}
                onPointerDown={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={handleClick}
            />
        </Wrapper>
    );
};
